export const DEBOUNCE_DELAY = 1000; // 1000ms = 1 second

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  // Add other status codes as needed
};

export const PARENT_GROUPS = {
  SPEEDY: "SPE",
};

export const ROUTE_NAMES = {
  DASHBOARD: "dashboard",
};

export const PRODUCT_STATUS = Object.freeze({
  ACTIVE: "active",
  DISABLED: "disabled",
  ARCHIVED: "archived",
  NOT_APPROVED: "not_approved",
  VISIBLE_NOT_ALLOWED_TO_BUY: "visible_not_allowed_to_buy",
});

export const CONSENT_TYPE = Object.freeze({
  ONBOARDING: "onboarding",
  BOOSTER_CCS_FORM: "booster-ccs-form",
});

export const CONSENT_TYPES = Object.values(CONSENT_TYPE);
